export function checkOnlyLetters(text) {
  const regex = /^[a-zA-Z ğüşöçıİĞÜŞÖÇ]*$/;
  return text === "" || regex.test(text);
}
